import * as React from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";

function Row(props) {
  const { row, handleRowClick } = props;
  const [open, setOpen] = React.useState(false);

  return (
    <React.Fragment>
      <TableRow
        sx={{
          "& > *": {
            borderBottom: "unset",
            padding: "4px 8px", // Reduced padding
          },
            backgroundColor: row.isReturn ? '#fff0f0' : 'transparent',
          color: row.isReturn ? '#d32f2f' : 'inherit',
          borderLeft: row.isReturn ? '3px solid #ff6b6b' : 'none',
          height: "35px", // Reduced row height
          cursor: "pointer",
        }}
        onClick={() => handleRowClick(row.id)}
      >
        <TableCell
          align="center"
          sx={{
            padding: "0px",
            "& svg": {
              fontSize: "22px", // Smaller icon
            },
          }}
          onClick={(e) => {
            e.stopPropagation();
            setOpen(!open);
          }}
        >
          <IconButton aria-label="expand row" size="small">
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell
          component="th"
          scope="row"
          sx={{
            fontSize: "0.875rem", // Smaller font
            padding: "4px 8px",
          }}
        >
          {row.id}
        </TableCell>
        <TableCell align="right">{row.total_qty}</TableCell>
        <TableCell align="right">{row.total_price}</TableCell>
        <TableCell align="right">{row.status}</TableCell>
        <TableCell align="right">{row.createdAt.toLocaleString()}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 1 }}>
              <Typography variant="h6" gutterBottom component="div">
                Detail of ({row.id})
              </Typography>
              <Table size="small" aria-label="purchases">
                <TableHead>
                  <TableRow>
                    <TableCell>ID</TableCell>

                    <TableCell>Product</TableCell>
                    <TableCell>SKU</TableCell>
                    <TableCell align="right">Size</TableCell>
                    <TableCell align="right">QTY</TableCell>
                    <TableCell align="right">Total price (PKR)</TableCell>
                    <TableCell align="right">Date</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {row.laam_order_details.map((historyRow) => (
                    <TableRow key={historyRow.id}>
                      <TableCell component="th" scope="row">
                        {historyRow.id}
                      </TableCell>
                      <TableCell>{historyRow.product_title}</TableCell>
                      <TableCell>{historyRow.laam_sku}</TableCell>
                      <TableCell align="right">
                        {historyRow.variant_title}
                      </TableCell>
                      <TableCell align="right">{historyRow.quantity}</TableCell>
                      <TableCell align="right">{historyRow.price}</TableCell>
                      <TableCell align="right">
                        {historyRow.createdAt}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}

export default function OrdersTable({ data, handleRowClick }) {
  return (
    <TableContainer component={Paper}>
      <Table aria-label="collapsible table">
        <TableHead>
          <TableRow
            sx={{
              "& > *": {
                padding: "4px 8px", // Reduced padding
              },
              height: "35px", // Reduced row height
            }}
          >
            <TableCell />
            <TableCell>Laam Order #</TableCell>
            <TableCell align="right">Total qty</TableCell>
            <TableCell align="right">Total Price&nbsp;(PKR)</TableCell>
            <TableCell align="right">Status</TableCell>
            <TableCell align="right">Date</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((row) => (
            <Row key={row.id} row={row} handleRowClick={handleRowClick}  style={row.isReturn ? { backgroundColor: '#fff0f0' } : {}} />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
